import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useRequest } from "@onefront/react-sdk";
import VaporPage from "@vapor/react-custom/VaporPage";
import { Stack } from "@vapor/react-material/Stack";
import { TextField } from "@vapor/react-material/TextField";
import { Box } from "@vapor/react-material/Box";
import { AdapterDateFns } from "@vapor/react-x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@vapor/react-x-date-pickers/LocalizationProvider";
import DatePicker from "@vapor/react-x-date-pickers/DatePicker";
import { Button } from "@mui/material";
import { useInvoicesForm } from "./state/useInvoiceForm";
import Card from "@vapor/react-material/Card";
import CardMedia from "@vapor/react-material/CardMedia";
import CardContent from "@vapor/react-material/CardContent";
import ExtendedTypography from "@vapor/react-extended/ExtendedTypography";

const product = {
  name: "string",
  image:
    "https://cdn.filestackcontent.com/resize=width:430,height:430,fit:crop,align:center/6Ib6iN86R7eRNuWKQHed",
  price: 25,
  company: "TS",
  vatRate: 0.1,
  discount: 0,
  netPrice: 42,
  grossPrice: 46.2,
};

const InvoiceCreate = () => {
  const [date, setDate] = useState<string>(new Date().toISOString().slice(0, 10));
  const [invoiceNumber, setInvoiceNumber] = useState<string>("");
  const [customerName, setCustomerName] = useState<string>("");
  const [totalAmount, setTotalAmount] = useState<string>("");

  const navigate = useNavigate();
  const { register, handleSubmit, errors } = useInvoicesForm();
  const { loading, data, error, fetch } = useRequest();

  const handleDateChange = (date: any) => {
    setDate(date.toISOString().slice(0, 10))
  };

  const onSubmit = () => {
    fetch({
      method: "post",
      lazy: true,
      url: "https://construction-next-test.service.ts-paas.com/api/Invoices",
      data: {
        date: date,
        products: [
          {
            name: "string",
            image:
              "https://cdn.filestackcontent.com/resize=width:430,height:430,fit:crop,align:center/6Ib6iN86R7eRNuWKQHed",
            price: 25,
            company: "TS",
            vatRate: 0.1,
            discount: 0,
            netPrice: 42,
            grossPrice: 46.2,
          },
        ],
        total_amount: parseInt(totalAmount),
        customer: customerName,
        name: invoiceNumber,
      },
    });
    navigate("/leadManagement");
  };

  if (loading) {
    return <p>Loading..</p>;
  }

  if (error) {
    return <p>Error:{error.message}</p>;
  }

  console.log(date);

  return (
    <VaporPage title="New Invoice">
      <VaporPage.Section>
        <Stack direction={"row"} display="flex" justifyContent="center" spacing={3} alignItems='center' mt="100px">
        <Box>
          <Card
            sx={{
              maxWidth: 345,
            }}
          >
            <CardMedia
              alt={product.image}
              component="img"
              height="200"
              image={product.image}
            />
            <CardContent>
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <Box
                  sx={{ display: "flex", flexDirection: "column", mt: "5px" }}
                >
                  <ExtendedTypography
                    variant="body"
                    sx={{ mt: "2px" }}
                  ></ExtendedTypography>
                  <ExtendedTypography variant="body" color="grey">
                    Price: $ {product.price}
                  </ExtendedTypography>
                  <ExtendedTypography variant="body" color="grey">
                    Discount: {product.discount}%
                  </ExtendedTypography>
                </Box>
                <Box
                  sx={{ display: "flex", flexDirection: "column", mt: "5px" }}
                >
                  <ExtendedTypography variant="body" color="grey">
                    Gross Price: $ {product.grossPrice}
                  </ExtendedTypography>
                  <ExtendedTypography variant="body" color="grey">
                    Net Price: $ {product.netPrice}
                  </ExtendedTypography>
                  <ExtendedTypography
                    variant="body"
                    color="grey"
                    sx={{ mt: "2px" }}
                  >
                    Vat Rate: {product.vatRate}%
                  </ExtendedTypography>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Box>
        <Box
          autoComplete="off"
          component="form"
          noValidate
          sx={{
            "& .MuiTextField-root": {
              m: 1,
              width: 250,
            },
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center', 
          }}
        >
          <Stack>
            <TextField
              id="outlined-required"
              label="Invoice Number"
              {...register("invoiceNumber")}
              error={!!errors.name}
              helperText={errors.name?.message as React.ReactNode}
              onChange={(e) => setInvoiceNumber(e.target.value)}
            />
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                label="Date"
                value={new Date(date)}
                onChange={(newDate) => handleDateChange(newDate)}
                renderInput={(props) => <TextField {...props} />}
                disableFuture
              />
            </LocalizationProvider>
            <TextField
              id="outlined-number"
              label="Customer Name"
              {...register("customerName")}
              error={!!errors.customer}
              helperText={errors.customer?.message as React.ReactNode}
              onChange={(e) => setCustomerName(e.target.value)}
            />

            <TextField
              id="outlined-number"
              label="Total Amount"
              type="number"
              {...register("totalAmount")}
              error={!!errors.total_amount}
              helperText={errors.total_amount?.message as React.ReactNode}
              onChange={(e) => setTotalAmount(e.target.value)}
            />
          </Stack>
          <Button variant="contained"  onClick={handleSubmit(onSubmit)}>
            Submit
          </Button>
        </Box>
        </Stack>
      </VaporPage.Section>
    </VaporPage>
  );
};

export default InvoiceCreate;
